const eventNames = {
  PRODUCT_TILE_CLICK: "product_tile_click",
  PRODUCT_PAGE_IMP: "product_page_impression",
  HOME_PAGE_IMP: "home_page_impression",
  HOME_PAGE_BANNER_CLICK: "home_page_banner_click",
  COD_FORM_VIEWED: "cod_form_viewed",
  COD_FORM_CLOSED: "cod_form_closed",
  PHONE_NUMBER_INPUT: "phone_number_input",
  ORDER_PLACED: "order_placed",
  BUY_WITH_COD_CLICK: "buy_with_cod_click",
  PLACE_ORDER_CLICK: "place_order_click",
  BUY_ONLINE_CLICK: "buy_online_click",
  ADD_TO_CART_CLICK: "add_to_cart_click",
};
const eventTypes = {
  CLICK: "click",
  IMPRESSION: "impression",
};
const actions = {
  PRODUCT_TILE_CLICK: "product_tile_click",
  VIEW: "view",
  BANNER_CLICK: "banner_click",
  BUY_WITH_COD: "buy_with_cod",
  ADD_TO_CART: "add_to_cart",
  BUY_ONLINE: "buy_online",
  COD_FORM_VIEWED: "cod_form_viewed",
  PLACE_ORDER: "place_order",
  FORM_CLOSED: "form_closed",
  PHONE_NUMBER_INPUT: "phone_number_input",
  ORDER_PLACED: "order_placed",
};
const eventContext = {
  PRODUCT_PAGE: "product_page",
  HOME_PAGE: "home_page",
  ORDER_CONFIRMATION_PAGE: "order_confirmation_page",
};
const eventNameActionMapper = {
  [eventNames.PRODUCT_TILE_CLICK]: actions.PRODUCT_TILE_CLICK,
  [eventNames.PRODUCT_PAGE_IMP]: actions.VIEW,
  [eventNames.HOME_PAGE_IMP]: actions.VIEW,
  [eventNames.HOME_PAGE_BANNER_CLICK]: actions.BANNER_CLICK,
  [eventNames.ADD_TO_CART_CLICK]: actions.ADD_TO_CART,
  [eventNames.COD_FORM_CLOSED]: actions.FORM_CLOSED,
  [eventNames.COD_FORM_VIEWED]: actions.COD_FORM_VIEWED,
  [eventNames.BUY_WITH_COD_CLICK]: actions.BUY_WITH_COD,
  [eventNames.PLACE_ORDER_CLICK]: actions.PLACE_ORDER,
  [eventNames.PHONE_NUMBER_INPUT]: actions.PHONE_NUMBER_INPUT,
};
const eventKeyNames = {
  eventType: "ety",
  action: "act",
  context: "ctx",
  extras: "ext",
  source: "src",
  timeStamp: "ts",
  userId: "uid",
  sessionId: "sid",
  storeHandle: "store_handle",
  productName: "product_name",
  price: "price",
  originalPrice: "original_price",
  shopifyProductId: "shopify_product_id",
  rating: "rating",
  utmSource: "utm_source",
  utmCampaign: "utm_campaign",
  fbClickId: "fbclickid",
  pageUrl: "page_url",
  timestamp: "ts",
  theme: "theme",
  destinationUrl: "destination_url",
  bannerPosition: "banner_position",
  imageUrl: "image_url",
  formDetails: "form_details",
  phoneNumber: "phone_number",
  status: "status",
};
const eventExtrasKeys = {};
const activePage = getCurrentPage();
let failedEventTimer = null;
const failedEventKeyName = "failedEvents";
const maxRetries = 3;
const stagingUrl =
  "https://api.cdn.zyxw365.in/metrics/shopify/analytics-events";
const productionUrl =
  "https://www.shop101.com/O1Server/metrics/shopify/analytics-events";
let analyticsAPIEndpoint =
  Shopify.theme.role === "main" ? productionUrl : stagingUrl;
const isRealeseItForm = window._RSI_COD_FORM_CSS_URL;
console.log("analyticsAPIEndpoint", analyticsAPIEndpoint);
let userId = localStorage.getItem("uid");
let sessionId = sessionStorage.getItem("sid");
if (!userId) {
  userId = generateUUID();
  localStorage.setItem("uid", userId);
}
if (!sessionId) {
  sessionId = generateUUID();
  sessionStorage.setItem("sid", sessionId);
}
function generateUUID() {
  let dt = new Date().getTime();
  let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      let r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

function removeUndefineNull(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] == null || obj[key] == "") delete obj[key];
  });
  return obj;
}

// This function will return current page like Home page product page etc.
function getCurrentPage() {
  const path = window.location.pathname;
  if (path.includes("product")) {
    return eventContext.PRODUCT_PAGE;
  } else if (path === "/") {
    return eventContext.HOME_PAGE;
  }
}
/**
 *
 * This function will trigger API call to send event data
 */
function triggerEvent(events) {
  events = events.map((event) => {
    delete event.retries;
    return event;
  });
  try {
    const isQueued = navigator.sendBeacon(
      analyticsAPIEndpoint,
      JSON.stringify(events)
    );
    if (!isQueued) {
      throw new Error("Failed to trigger event");
    }
  } catch (err) {
    console.error("Failed to trigger event", err);
    handleAPIFailed(events);
  }
}
/**
 *
 * @param {*} eventName: Name of event will be unique for each event
 * @param {*} data: this will json data for the event
 * handleAnalytics function will be called on each event and it will generate event data and trigger the event
 */
function handleAnalytics(eventName, data) {
  console.log(
    "handleAnalytics",
    eventName,
    window.ShopifyAnalytics?.meta?.product?.id,
    ShopifyAnalytics,
    JSON.stringify(data)
  );
  const { utm_campaign = "", utm_source = "" } = getQueryParams();
  const event = {
    [eventKeyNames.timestamp]: Date.now(),
    [eventKeyNames.eventType]: eventTypes.CLICK,
    [eventKeyNames.action]: eventNameActionMapper[eventName],
    [eventKeyNames.context]: activePage,
    [eventKeyNames.storeHandle]: Shopify.shop,
    [eventKeyNames.productName]: data[eventKeyNames.productName],
    [eventKeyNames.price]: data[eventKeyNames.price],
    [eventKeyNames.originalPrice]: data[eventKeyNames.originalPrice],
    [eventKeyNames.shopifyProductId]: data[eventKeyNames.shopifyProductId],
    [eventKeyNames.userId]: userId,
    [eventKeyNames.sessionId]: sessionId,
    [eventKeyNames.extras]: {
      [eventKeyNames.fbClickId]: getCookie("_shopify_sa_p"),
      [eventKeyNames.utmSource]: utm_source,
      [eventKeyNames.utmCampaign]: utm_campaign,
      [eventKeyNames.pageUrl]: window.location.href,
      [eventKeyNames.theme]: Shopify.theme.name,
      [eventKeyNames.destinationUrl]: data[eventKeyNames.destinationUrl],
      [eventKeyNames.bannerPosition]: data[eventKeyNames.bannerPosition],
      [eventKeyNames.imageUrl]: data[eventKeyNames.imageUrl],
      [eventKeyNames.phoneNumber]: data[eventKeyNames.phoneNumber],
      [eventKeyNames.formDetails]: data[eventKeyNames.formDetails],
      [eventKeyNames.status]: data[eventKeyNames.status],
    },
  };
  switch (eventName) {
    case eventNames.HOME_PAGE_IMP:
      event[eventKeyNames.eventType] = eventTypes.IMPRESSION;
      break;
    case eventNames.ORDER_PLACED:
      event.context = eventContext.ORDER_CONFIRMATION_PAGE;
      break;
    case eventNames.COD_FORM_VIEWED:
    case eventNames.PRODUCT_PAGE_IMP:
      event[eventKeyNames.eventType] = eventTypes.IMPRESSION;
    case eventNames.BUY_WITH_COD_CLICK:
    case eventNames.COD_FORM_CLOSED:
    case eventNames.PHONE_NUMBER_INPUT:
    case eventNames.PLACE_ORDER_CLICK:
      event[eventKeyNames.shopifyProductId] =
        window.ShopifyAnalytics?.meta?.product?.id;
      event[eventKeyNames.productName] =
        window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.name;
      event[eventKeyNames.price] =
        window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price;
      break;
  }
  const finalEvent = removeUndefineNull({
    ...removeUndefineNull(event),
    [eventKeyNames.extras]: JSON.stringify(
      removeUndefineNull(event[eventKeyNames.extras])
    ),
  });
  finalEvent.retries = 0;
  triggerEvent([finalEvent]);
}

function getCookie(name) {
  let cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null; // Return null if cookie is not found
}
function handleAPIFailed(events) {
  events = events
    .filter((event) => event.retries < maxRetries)
    .map((event) => {
      event.retries += 1;
      return event;
    });
  let failedEvents = JSON.parse(localStorage.getItem(failedEventKeyName)) || [];
  if (events.length > 0) {
    failedEvents = [...failedEvents, ...events];
    localStorage.setItem(failedEventKeyName, JSON.stringify(failedEvents));
    if (!failedEventTimer) {
      initialiseFailedEventTimer();
    }
  }
}
function handleFailedEventTrigger() {
  const failedEvents =
    JSON.parse(localStorage.getItem(failedEventKeyName)) || [];
  localStorage.setItem(failedEventKeyName, JSON.stringify([]));
  if (failedEvents.length === 0) {
    clearInterval(failedEventTimer);
    failedEventTimer = null;
  } else {
    triggerEvent(failedEvents);
  }
}
function initialiseFailedEventTimer() {
  failedEventTimer = setInterval(handleFailedEventTrigger, 1000);
}
/**
 * This is IIFE function which will be called on page load and it will trigger impression event for that page
 */
(() => {
  switch (activePage) {
    case eventContext.PRODUCT_PAGE:
      handleAnalytics(eventNames.PRODUCT_PAGE_IMP, {});
      handleCODClickAnalytics();
      break;
    case eventContext.HOME_PAGE:
      handleAnalytics(eventNames.HOME_PAGE_IMP, {});
      break;
    default:
      break;
  }
})();

function handleCODClickAnalytics() {
  const buyNowFooterSelector = isRealeseItForm
    ? "#_rsi-buy-now-button-floating > #_rsi-buy-now-button"
    : "button#buy-now-footer";
  const esPopupButtonSelector = isRealeseItForm
    ? ".product-form__buttons > #_rsi-buy-now-button"
    : "div#es-popup-button";
  const clickHandler = () => {
    handleAnalytics(eventNames.BUY_WITH_COD_CLICK, {});
    handleCODFormViewAnalytics();
  };
  if (isRealeseItForm) {
    waitForElm(buyNowFooterSelector).then((elm) => {
      elm.addEventListener("click", clickHandler);
    });
  }

  waitForElm(esPopupButtonSelector).then((elm) => {
    elm.addEventListener("click", clickHandler);
  });
}

function handleCODFormViewAnalytics() {
  let modalSelector = "div#easysell-modal";
  if (isRealeseItForm) {
    modalSelector = "div#_rsi-cod-form-modal";
    const placeOrderButtonSelector = "._rsi-build-block-submit-button > button";
    this.placeOrderButton = document.querySelector(placeOrderButtonSelector);
    if (this.placeOrderButton) {
      this.placeOrderButton.style = "";
    }
  }
  const observer = new MutationObserver((mutations) => {
    if (
      document.querySelector(modalSelector) &&
      !isElementHidden(document.querySelector(modalSelector))
    ) {
      handleCODFormEvents();
      handleAnalytics(eventNames.COD_FORM_VIEWED, {});
      observer.disconnect();
    } else {
      console.log("modal closed");
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function handleCODFormEvents() {
  const closeButtonSelector = isRealeseItForm
    ? "#_rsi-cod-form-modal-close"
    : "#es-form .es-modal-header>.close-icon";
  const placeOrderButtonSelector = isRealeseItForm
    ? "._rsi-build-block-submit-button > button"
    : "#es-form-button";
  const phoneInputSelector = isRealeseItForm
    ? "#_rsi-field-phone"
    : "#es-form input[id=es-phone]";
  const formSelector = isRealeseItForm
    ? "form#_rsi-cod-form-modal-form"
    : "form#es-form";
  const closeEvent = () => {
    handleAnalytics(eventNames.COD_FORM_CLOSED, {
      [eventKeyNames.formDetails]: getFormData(formSelector),
    });
    waitForElm(closeButtonSelector).then((closeButton) => {
      closeButton?.removeEventListener("click", closeEvent);
    });
    waitForElm(placeOrderButtonSelector).then((placeOrderButton) => {
      placeOrderButton?.removeEventListener("click", placeOrderClickEvent);
    });
    waitForElm(phoneInputSelector).then((phoneInput) => {
      phoneInput?.removeEventListener("focusout", phoneInputEvent);
    });
  };
  const placeOrderClickEvent = () => {
    const isFormValid = document.querySelector(formSelector).checkValidity();
    handleAnalytics(eventNames.PLACE_ORDER_CLICK, {
      [eventKeyNames.formDetails]: getFormData(formSelector),
      [eventKeyNames.status]: isFormValid ? "success" : "failed",
    });
  };
  const phoneInputEvent = (e) => {
    handleAnalytics(eventNames.PHONE_NUMBER_INPUT, {
      [eventKeyNames.phoneNumber]: e.target.value,
      [eventKeyNames.formDetails]: getFormData(formSelector),
    });
  };

  waitForElm(closeButtonSelector).then((closeButton) => {
    closeButton?.addEventListener("click", closeEvent);
  });
  waitForElm(placeOrderButtonSelector).then((placeOrderButton) => {
    placeOrderButton?.addEventListener("click", placeOrderClickEvent);
  });
  waitForElm(phoneInputSelector).then((phoneInput) => {
    phoneInput?.addEventListener("focusout", phoneInputEvent);
  });
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function isElementHidden(element) {
  const style = window.getComputedStyle(element);
  return (
    style.display === "none" ||
    style.visibility === "hidden" ||
    style.opacity === "0"
  );
}

function getFormData(formSelector) {
  const form = document.querySelector(formSelector);
  const formData = new FormData(form);
  const data = {};
  for (let [key, value] of formData.entries()) {
    data[key] = value;
  }
  const stateSelect = document.querySelector(`${formSelector} select`);
  return {
    name: data.first_name,
    phone: data.phone,
    pincode: data.zip,
    address: data.address,
    landmark: data.address2,
    city: data.city,
    state:
      stateSelect?.selectedIndex === 0
        ? ""
        : stateSelect?.selectedOptions?.[0]?.innerText?.trim(),
  };
}
function getQueryParams() {
  return Object.fromEntries(new URLSearchParams(window.location.search));
}
